import { render, staticRenderFns } from "./AsideBarItem.vue?vue&type=template&id=b6189b5a&scoped=true&"
import script from "./AsideBarItem.vue?vue&type=script&lang=js&"
export * from "./AsideBarItem.vue?vue&type=script&lang=js&"
import style0 from "./AsideBarItem.vue?vue&type=style&index=0&id=b6189b5a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6189b5a",
  null
  
)

export default component.exports